/** Action liée au scenario */
export enum ScenarioTypes {
  // transactions
  FETCH_TRANSACTION = "FETCH_TRANSACTION",
  FETCH_TRANSACTION_SUCCESS = "FETCH_TRANSACTION_SUCCESS",
  FETCH_TRANSACTION_ERROR = "FETCH_TRANSACTION_ERROR"
}

/** action liée au contextes */
export enum ContextTypes {
  SELECT_CONTEXT = "SELECT_CONTEXT",
  FETCH_CONTEXT = "FETCH_CONTEXT",
  FETCH_CONTEXT_SUCCESS = "FETCH_CONTEXT_SUCCESS"
}

/** on combine toutes les actions ensembles */
export const ActionTypes = {
  ScenarioTypes,
  ContextTypes
};
